// extracted by mini-css-extract-plugin
export default {"times":"SlotSelect_times__uWbQd","timesList":"SlotSelect_timesList__xV-5P"};